import { Request, CategoryNameValidation } from '@/helpers'

import {
    COMPONENT_DEFAULT_ERRORS,
    COMPONENT_DEFAULT_FORM,
    ENDPOINTS
} from '@/data'

const Update = async (props: ClientCategoryUpdateFunctionProps) => {
    const {
        Categories,
        SetCategoryState,
        Form,
        Errors,
        SetState,
        InitNotification
    } = props

    try {
        const { _id, Name } = Form

        const clone_errors = structuredClone(Errors)
        Object.keys(clone_errors).forEach(key => { clone_errors[key] = true })

        SetState({ Errors: clone_errors })

        const nameIsValid = CategoryNameValidation(Name)

        if (!nameIsValid.error) {
            SetState({ Loading: true })

            const sideover_panel = document.querySelector('#sideover-panel')

            if (sideover_panel) sideover_panel.scrollBy({
                top: -sideover_panel.scrollHeight,
                behavior: 'smooth'
            })

            const { success, message, data } = await Request({
                path: ENDPOINTS.UPDATE_CATEGORY,
                method: 'PATCH',
                body: {
                    id: _id,
                    name: Name
                }
            })

            if (success && data) {
                const categories = structuredClone(Categories)
                const index = categories.findIndex(category => category._id === _id)

                categories[index] = data
                SetCategoryState({ Categories: categories })

                const components_panel = document.querySelector('#component-list')

                if (components_panel) components_panel.scrollBy({
                    top: -components_panel.scrollHeight,
                    behavior: 'smooth'
                })

                InitNotification(message)

                SetState({
                    Form: COMPONENT_DEFAULT_FORM,
                    Errors: COMPONENT_DEFAULT_ERRORS,
                    Loading: false,
                    Mode: 'create',
                    Open: false
                })
            }

            else {
                InitNotification(message)
                SetState({ Loading: false })
            }
        }
    }

    catch (error) {
        console.error(error)

        InitNotification('Something went wrong while trying to update Category!')
        SetState({ Loading: false })
    }
}

export default Update
